<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <b>我的任务</b>
        <div class="tips">
          <span
            ><i class="uc-blue">{{ list.total_count }}</i> 项任务</span
          >
        </div>
      </div>
      <div class="search" style="width:300px;">
        <el-input
          v-model="query.keyword"
          placeholder="请输入搜索关键字"
          style="width:180px;"
          suffix-icon="el-icon-search"
          @change="
            query.pageIndex = 1;
            initData();
          "
        >
        </el-input>
        <el-button
          icon="el-icon-plus"
          @click="
            dialogTaskVisible = true;
            initRelationData();
          "
          >填报任务</el-button
        >
      </div>
    </div>

    <section class="uc-examList">
      <div class="content-empty" v-if="list.total_count == 0">
        <div class="emptyimg-box"></div>
        <p>暂无相关内容</p>
      </div>
      <div v-for="(item, index) in list.items" :key="index" class="item">
        <div class="title">
          <div class="c el-icon-s-operation">
            {{ item.title }}
          </div>
          <router-link
            to=""
            @click.native="
              dialogTaskVisible = true;
              initRelationData();
              getTaskDetails(item.id);
            "
            v-if="item.is_self && item.approval_status !== 1"
          >
            <i class="el-icon-edit"></i>
          </router-link>
        </div>
        <div class="con">
          <div class="sub-item w50">
            <i class="el-icon-s-custom"></i> 创建人：{{ item.create_user_name }}
          </div>
          <div class="sub-item w50">
            <i class="el-icon-time"></i> 任务期限：{{ item.start_time }} ~
            {{ item.finish_time }}
          </div>
          <div
            v-bind:class="{ expansion: item.is_long_content }"
            class="sub-item w100"
            v-html="`<i class=el-icon-document></i> 任务内容：${item.content}`"
          ></div>
          <el-button
            type="text"
            v-if="item.is_show_content"
            v-on:click="item.is_long_content = !item.is_long_content"
          >
            <span
              v-html="
                item.is_long_content
                  ? '展开内容<i class=el-icon-arrow-down></i>'
                  : '收起内容<i class=el-icon-arrow-up></i>'
              "
            >
            </span>
          </el-button>
          <div
            v-bind:class="{ expansion: item.is_long_objective }"
            class="sub-item w100"
            v-html="
              `<i class=el-icon-document></i> 达成目标：${item.objective}`
            "
          ></div>
          <div class="sub-item w100">
            <el-button
              type="text"
              v-if="item.is_show_objective"
              v-on:click="item.is_long_objective = !item.is_long_objective"
            >
              <span
                v-html="
                  item.is_long_objective
                    ? '展开目标<i class=el-icon-arrow-down></i>'
                    : '收起目标<i class=el-icon-arrow-up></i>'
                "
              >
              </span>
            </el-button>
          </div>
          <div class="sub-item w50">
            <i class="el-icon-connection"></i> 任务状态：<span
              v-if="item.approval_status == 0"
            >
              <el-tag type="warning" size="small">
                {{ item.approval_status_text }}
              </el-tag>
            </span>
            <span v-else-if="item.approval_status == 1">
              <el-tag type="success" size="small">
                {{ item.approval_status_text }}
              </el-tag>
            </span>
            <span v-else>
              <el-tag type="danger" size="small">
                {{ item.approval_status_text }}
              </el-tag>
              <i class="el-icon-arrow-right"></i>
              <el-button
                type="text"
                v-on:click="handleClickReason(`${item.approval_reason}`)"
                >驳回原因</el-button
              >
            </span>
          </div>
          <div class="sub-item w50" v-if="item.approval_status == 1">
            <i class="el-icon-connection"></i> 任务反馈：
            <span v-if="item.is_started">
              <span v-if="item.task_users[0].feedback">
                <span v-if="item.task_users[0].approval_status == 0">
                  <el-tag type="warning" size="small">
                    {{ item.task_users[0].approval_status_text }}
                  </el-tag>
                  <i class="el-icon-arrow-right"></i>
                  <el-button
                    type="text"
                    v-on:click="
                      dialogFeedbackVisible = true;
                      getFeedbackDetails(item.task_users[0]);
                    "
                    >查看反馈</el-button
                  >
                </span>
                <span v-else-if="item.task_users[0].approval_status == 1">
                  <el-tag type="success" size="small">
                    {{ item.task_users[0].approval_status_text }}
                  </el-tag>
                  <i class="el-icon-arrow-right"></i>
                  <el-button
                    type="text"
                    v-on:click="
                      dialogFeedbackDetailsVisible = true;
                      getFeedbackDetails(item.task_users[0]);
                    "
                    >查看评论</el-button
                  >
                </span>
                <span v-else>
                  <el-tag type="danger" size="small">
                    {{ item.task_users[0].approval_status_text }}
                  </el-tag>
                  <i class="el-icon-arrow-right"></i>
                  <el-button
                    type="text"
                    v-on:click="
                      handleClickReason(`${item.task_users[0].approval_reason}`)
                    "
                    >驳回原因</el-button
                  >
                  <i class="el-icon-arrow-right"></i>
                  <el-button
                    type="text"
                    v-on:click="
                      dialogFeedbackVisible = true;
                      getFeedbackDetails(item.task_users[0]);
                    "
                    >再次编辑</el-button
                  >
                </span>
              </span>
              <span v-else>
                <el-tag type="info" size="small">未反馈</el-tag>
                <i class="el-icon-arrow-right"></i>
                <el-button
                  type="text"
                  v-on:click="
                    dialogFeedbackVisible = true;
                    feedbackForm.id = item.task_users[0].id;
                  "
                  >写反馈</el-button
                >
              </span>
            </span>
            <span v-else
              ><el-tag type="info" size="small">任务未开始</el-tag></span
            >
          </div>
        </div>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>

    <el-dialog
      title="师徒任务"
      :visible.sync="dialogTaskVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseTaskDialog"
    >
      <el-form :model="taskForm" ref="taskForm" :rules="taskRules">
        <el-form-item
          label="ID"
          prop="id"
          :label-width="formLabelWidth"
          style="display:none;"
        >
          <el-input v-model="taskForm.id"></el-input>
        </el-form-item>
        <el-form-item
          label="任务期限"
          prop="task_time"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="taskForm.task_time"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="完成日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="汇报对象"
          prop="master_id"
          :label-width="formLabelWidth"
        >
          <el-select
            style="width:100%;"
            v-model="taskForm.master_id"
            placeholder="请选择师傅"
          >
            <el-option
              v-for="(item, index) in relationList"
              :key="index"
              :label="item.master_name"
              :value="item.master_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="任务标题"
          prop="title"
          :label-width="formLabelWidth"
        >
          <el-input v-model.trim="taskForm.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="任务内容"
          prop="content"
          :label-width="formLabelWidth"
        >
          <el-input
            type="textarea"
            v-model.trim="taskForm.content"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="达成目标"
          prop="objective"
          :label-width="formLabelWidth"
        >
          <el-input
            type="textarea"
            v-model.trim="taskForm.objective"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancleTask">取 消</el-button>
        <el-button type="primary" @click.native="handleTaskSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="任务反馈"
      :visible.sync="dialogFeedbackVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseFeedbackDialog"
    >
      <el-form :model="feedbackForm" ref="feedbackForm" :rules="feedbackRules">
        <el-form-item
          label="ID"
          prop="id"
          :label-width="formLabelWidth"
          style="display:none;"
        >
          <el-input v-model="feedbackForm.id"></el-input>
        </el-form-item>
        <el-form-item
          label="内容"
          prop="feedback"
          :label-width="formLabelWidth"
        >
          <el-input
            type="textarea"
            v-model.trim="feedbackForm.feedback"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="file" :label-width="formLabelWidth">
          <el-upload
            :multiple="false"
            :action="uploadParam.actionUrl"
            :limit="uploadParam.limitNum"
            :file-list="uploadParam.fileList"
            :auto-upload="false"
            :before-upload="beforeUploadFile"
            :on-change="handleFileChange"
            :on-exceed="handleExceed"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-remove="handleRemove"
            :on-preview="handlePreview"
          >
            <el-button size="small" type="primary">选择附件</el-button>
            <div slot="tip" class="el-upload__tip">
              上传文件不超过5M
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancleFeedback">取 消</el-button>
        <el-button type="primary" @click.native="handleFeedbackSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="任务反馈"
      :visible.sync="dialogFeedbackDetailsVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-form :model="feedbackDetailsForm" ref="feedbackDetailsForm">
        <el-form-item
          label="ID"
          prop="id"
          :label-width="formLabelWidth"
          style="display:none;"
        >
          <el-input v-model="feedbackDetailsForm.id"></el-input>
        </el-form-item>
        <el-form-item
          label="反馈内容"
          prop="feedback"
          :label-width="formLabelWidth"
        >
          <span v-html="feedbackDetailsForm.feedback"></span>
        </el-form-item>
        <el-form-item
          label="反馈附件"
          prop="feedback_url"
          :label-width="formLabelWidth"
        >
          <span v-if="feedbackDetailsForm.feedback_url">
            <i class="el-icon-link"></i>
            <el-link
              :underline="false"
              :href="feedbackDetailsForm.feedback_url"
              target="_blank"
              type="primary"
              >下载</el-link
            >
          </span>
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="评分" prop="score" :label-width="formLabelWidth">
          <el-rate
            v-model="feedbackDetailsForm.score"
            disabled
            show-score
            score-template="{value}分"
            style="line-height:2.8;"
          ></el-rate>
        </el-form-item>
        <el-form-item
          label="实际完成"
          prop="actual_finish_time"
          :label-width="formLabelWidth"
        >
          <span>{{ feedbackDetailsForm.actual_finish_time }}</span>
        </el-form-item>
        <el-form-item
          label="评论内容"
          prop="evaluation"
          :label-width="formLabelWidth"
        >
          <span v-html="feedbackDetailsForm.evaluation"></span>
        </el-form-item>
        <el-form-item
          label="评论人"
          prop="approval_user_name"
          :label-width="formLabelWidth"
        >
          <span
            v-html="
              `${feedbackDetailsForm.approval_user_name} · ${feedbackDetailsForm.approval_time}`
            "
          ></span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click.native="dialogFeedbackDetailsVisible = false"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ApprenticeTask',
  data() {
    return {
      query: {
        type: 0,
        apprenticeId: undefined,
        pageIndex: 1,
        pageSize: 10,
        keyword: undefined,
      },
      queryRelation: {
        type: 0,
        relationStatus: undefined,
      },
      list: [],
      relationList: [],
      dialogTaskVisible: false,
      pickerOptions: {
        disabledDate: (time) => {
          const one = 1 * 24 * 60 * 60 * 1000;
          const now = Date.now() - one;
          return time.getTime() < now;
        },
      },
      taskForm: {
        id: 0,
        master_id: undefined,
        task_time: '',
        title: '',
        content: '',
        objective: '',
      },
      taskRules: {
        master_id: [{ required: true, message: '请选择师傅', trigger: 'blur' }],
        task_time: [{ required: true, message: '请选择日期', trigger: 'blur' }],
        title: [{ required: true, message: '请输入任务标题', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入任务内容', trigger: 'blur' },
        ],
        objective: [
          { required: true, message: '请输入达成目标', trigger: 'blur' },
        ],
      },
      dialogFeedbackVisible: false,
      feedbackForm: {
        id: 0,
        feedback: '',
        file: '',
      },
      feedbackRules: {
        feedback: [
          { required: true, message: '请输入反馈内容', trigger: 'blur' },
        ],
      },
      formLabelWidth: '100px',
      uploadParam: {
        limitNum: 1,
        fileList: [],
        actionUrl: '',
      },
      dialogFeedbackDetailsVisible: false,
      feedbackDetailsForm: {},
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getShituTasks();
    },
    initRelationData() {
      this.getShituRelations();
    },
    async getShituRelations() {
      const response = await this.$api.shitu.getShituRelations(
        this.queryRelation
      );
      this.relationList = response.data.data;
    },
    async getShituTasks() {
      const response = await this.$api.shitu.getShituTasks(this.query);
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },
    // ------------------新增&编辑任务-Begin------------------
    async getTaskDetails(itemId) {
      const response = await this.$api.shitu.getTaskDetails({
        type: 0,
        id: itemId,
      });
      this.$nextTick(() => {
        this.taskForm = response.data.data;
      });
    },
    async editShituTask(task) {
      const response = await this.$api.shitu.apprenticeEditShituTask(task);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.dialogTaskVisible = false;
        this.initData();
        // 清空表单
        this.$nextTick(() => {
          this.$refs.taskForm.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 提交数据
    handleTaskSubmitSure() {
      const submitData = {
        id: this.taskForm.id,
        master_id: this.taskForm.master_id,
        task_time: this.taskForm.task_time,
        title: this.taskForm.title,
        content: this.taskForm.content,
        objective: this.taskForm.objective,
      };
      this.$refs.taskForm.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.editShituTask(submitData);
        }
      });
    },
    handleCloseTaskDialog() {
      this.$refs.taskForm.resetFields();
    },
    handleCancleTask() {
      this.dialogTaskVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.taskForm.resetFields();
      });
    },
    // ------------------新增&编辑任务-End------------------

    // ------------------任务反馈-Begin------------------
    // 查看驳回原因
    handleClickReason(reason) {
      this.$alert(reason, '驳回原因', {
        dangerouslyUseHTMLString: true,
      });
    },
    async getFeedbackDetails(item) {
      this.$nextTick(() => {
        this.feedbackForm.id = item.id;
        this.feedbackForm.feedback = item.feedback;
        if (item.feedback_url !== '') {
          this.uploadParam.fileList = [
            { name: item.attachment_name, url: item.feedback_url },
          ];
        }
        this.feedbackDetailsForm = item;
      });
    },
    async editFeedback(feedback) {
      const response = await this.$api.shitu.editFeedback(feedback);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);
        this.dialogFeedbackVisible = false;
        this.initData();
        // 清空表单
        this.$nextTick(() => {
          this.$refs.feedbackForm.resetFields();
          // 移除文件列表
          this.uploadParam.fileList = [];
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 提交数据
    handleFeedbackSubmitSure() {
      const submitData = new FormData();
      submitData.append('id', this.feedbackForm.id);
      submitData.append('feedback', this.feedbackForm.feedback);
      if (this.uploadParam.fileList.length > 0) {
        submitData.append('file', this.feedbackForm.file);
      }
      this.$refs.feedbackForm.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.editFeedback(submitData);
        }
      });
    },
    handleCloseFeedbackDialog() {
      this.$refs.feedbackForm.resetFields();
      // 移除文件列表
      this.uploadParam.fileList = [];
    },
    handleCancleFeedback() {
      this.dialogFeedbackVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.feedbackForm.resetFields();
        // 移除文件列表
        this.uploadParam.fileList = [];
      });
    },
    // ------------------任务反馈-End------------------

    // ------------------任务反馈附件上传-Begin------------------
    // 文件状态改变时的钩子
    handleFileChange(file, fileList) {
      // console.log('change');
      // console.log(file);
      this.feedbackForm.file = file.raw;
      if (fileList.length > 0) {
        this.uploadParam.fileList.pop();
        this.uploadParam.fileList.push(file.raw);
      }
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      // console.log('before upload');
      // console.log(file);
      // let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      const size = file.size / 1024 / 1024;
      if (size > 5) {
        this.$message.error(`上传文件大小不能超过 5MB!`);
        return false;
      }
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message({
        message: `只能选择 ${
          this.uploadParam.limitNum
        } 个文件，当前共选择了 ${files.length + fileList.length} 个`,
        type: 'warning',
      });
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message({
        message: '文件上传成功',
        type: 'success',
      });
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message({
        message: '文件上传失败',
        type: 'error',
      });
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      if (file && file.status === 'success') {
        // 移除方法
        this.uploadParam.fileList.splice(0, 1);
      }
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {
      if (file && file.status === 'success') {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.href = file.url;
        link.click();
      }
    },
    // ------------------任务反馈附件上传-End------------------
  },
};
</script>
